export enum UserInfoErrors {
    Default = 'USER_INFO_ERROR',
    CustomerNotFound = 'CUSTOMER_NOT_FOUND',
}
